import { gql } from '../../../../../types/__codegen__/ahm-api';

export const VALIDATE_REFERRAL_CODE_QUERY = gql(`
  query validateReferralCode($referralCode: String) {
    validateReferralCode(referralCode: $referralCode) {
      isValid
    }
  }
`);
